import { ReactNode } from "react";

export default function SectionLabel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <p className={`text-eyebrow uppercase text-faint mt-8 mb-3 ${className}`}>{children}</p>
  );
}
